import useNTGroupData from "../../../state/nationalTeamGroup/UseNTGroupData";
import useNTGroupMembersData from "../../../state/nationalTeamGroup/nationalTeamGroupMembers/UseNTGroupMembersData";

import useMemberPersistentStorage from "@usas/ui-web/state/memberPersistentStorage/UseMemberPersistentStorage";
import useGlobalRoutesData from "@usas/ui-web/state/security/UseGlobalRoutesData";

import { UI_PROJECT_NAMES } from "@usas/ui-web/utils/Constants";
import formatCrossUiRoute from "@usas/ui-web/utils/FormatCrossUiRoute";

const useNTGroupAthletesBulkAdd = (updateAthletePillStep) => {
  const { onNTGroupsError } = useNTGroupData();
  const { setPersistentStorage } = useMemberPersistentStorage();
  const { getGlobalRoute } = useGlobalRoutesData();
  const { groupMembersState, putNTGroupMembers } = useNTGroupMembersData();

  const onEditGroupAthleteClicked = (event, groupAthleteObj) => {
    try {
      event?.preventDefault();
      event?.stopPropagation();
      setPersistentStorage(
        groupAthleteObj.personId,
        UI_PROJECT_NAMES.MEMBER,
        '/',
        'Back to Member Search'
      );

      const routeObj = getGlobalRoute('MEMBER_NT_ADVANCED_INFO');
      const crossUiRoute = formatCrossUiRoute(routeObj?.uIProjectName, routeObj?.route, true);
      window.open(crossUiRoute.route, '_blank');
    } catch (e) {
      onNTGroupsError(e);
    }
  };

  const onSubmitAthletesFormGrid = (formGridState) => {
    try {
      const groupMembersArray = [...formGridState];

      const putNTGroupMembersPromise = putNTGroupMembers(groupMembersState.nationalTeamGroupId, groupMembersArray, false);

      if (putNTGroupMembersPromise ?? false) {
        putNTGroupMembersPromise.then((newState) => {
          if (newState ?? false) {
            updateAthletePillStep(newState.objData);
          }
        }).catch((e) => {
          onNTGroupsError(e);
        });
      }
    } catch (e) {
      onNTGroupsError(e);
    }
  };

  return {
    isSaving: groupMembersState.isObjLoading,
    gridData: groupMembersState.objData?.nationalTeamGroupMember || [],
    onSubmitAthletesFormGrid,
    onEditGroupAthleteClicked
  };
};

export default useNTGroupAthletesBulkAdd;